export default "/images/vendor/flag-icon-css/flags/4x3/ye.svg?f62afcddf3ac8b1dfd3e9b0e67ba23bd";